export default "__VITE_ASSET__CpXC3u$j__"